import ApiService from './ApiService';
import * as queryString from 'query-string';

export default class TemplatesService {
  static fetchAll(params) {
    return ApiService.get(`/themes?${queryString.stringify(params)}`);
  }

  static fetchOne(slugOrId) {
    return ApiService.get(`/themes/${slugOrId}`);
  }

  static fetchOneContent(id) {
    return ApiService.get(`/themes/${id}/content`);
  }

  static create(data) {
    return ApiService.post('/themes', data);
  }

  static update(id, data) {
    return ApiService.put(`/themes/${id}`, data);
  }

  static applyTemplateToCreation(id, data) {
    return ApiService.post(`/themes/${id}/apply`, data);
  }
}
